import { render, staticRenderFns } from "./TopInfo.vue?vue&type=template&id=395a2b7b"
import script from "./TopInfo.vue?vue&type=script&lang=js"
export * from "./TopInfo.vue?vue&type=script&lang=js"
import style0 from "./TopInfo.vue?vue&type=style&index=0&id=395a2b7b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports